import React, { useState } from 'react';
import { Modal, Form, FormControl, ListGroup, Button, Card, Row, Col } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';

const ModalCollectibleList = ({ show, buildItem, filteredItemsCb, onSubmit, handleClose, items = [], id }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);

  const filteredItems = items.filter(item => filteredItemsCb(item, searchTerm));

  const handleItemClick = (item) => {
    if (isContain(item)) {
      const newArr = selectedItems.filter(e => e[id || 'id'] !== item[id || 'id']);
      setSelectedItems([...newArr]);
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  const handleReturnSelectedItems = () => {
    onSubmit(selectedItems); // Clear selected items array
  };

  const isContain = (item) => {
    return selectedItems.map(e => e[id || 'id']).includes(item[id || 'id']);
  }

  return (
    <Modal show={show} onHide={handleClose} scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Searchable List Modal</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="search" className="mb-2">
          <Form.Control
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Form.Group>
        {filteredItems.map((item, index) => (
          <Card key={index} className="mb-2">
            <Card.Body>
              <Row>
                <Col>
                  {buildItem(item)}
                </Col>
                <Col xs="auto">
                  <Button
                    size='sm'
                    variant={isContain(item) ? "danger" : "secondary"}
                    onClick={() => handleItemClick(item)}
                  >
                    <FontAwesomeIcon icon={isContain(item) ? faTimes : faPlus} />
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <div className="d-grid gap-2">
          <Button variant="primary" onClick={handleReturnSelectedItems}>Simpan</Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCollectibleList;
